export default function jsonCopy(object) {
    let json = JSON.stringify(object);
    return JSON.parse(json);
}
